import { Component } from '@angular/core';

@Component({
    selector: 'app-under-construction',
    templateUrl: './under-construction.component.html',
    styleUrl: './under-construction.component.scss',
    standalone: true
})
export class UnderConstructionComponent {
}
